import { useQuery } from '@tanstack/react-query';
import { getDownloadTemplateBudget } from 'services/api/requests/uploads/uploads';
export const useDownloadTemplateBudget = () => {
	return useQuery(['download-template-budget'], getDownloadTemplateBudget, {
		refetchOnWindowFocus: false,
		enabled: false,
	});
};
